import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { BonusSystem, ClientDiscount } from './components';

export const LoyaltySystem: FC = () => {
  const { t } = useContext(LocalizationContext);
  return (
    <>
      <SettingsBlock title={t('nav.loyalty')}>
        <SettingsFrame>
          <BonusSystem />
        </SettingsFrame>

        <SettingsFrame>
          <ClientDiscount />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
